import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getRedirect } from "@/lib/seo-redirects";

/**
 * Component to handle 301 redirects and URL normalization
 * - Handles trailing slashes (redirects /page/ to /page)
 * - Handles configured 301 redirects
 * Place this at the root of your app
 */
const RedirectHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathname = location.pathname;
    const search = location.search;
    
    // CRITICAL: Normalize trailing slashes (except root /)
    // /page/ → /page (301 redirect to canonical version)
    if (pathname !== '/' && pathname.endsWith('/')) {
      const normalizedPath = pathname.slice(0, -1);
      console.log(`[SEO Normalize] Trailing slash removed: ${pathname} → ${normalizedPath}`);
      navigate(normalizedPath + search, { replace: true });
      return;
    }
    
    // Check for configured redirects
    const redirectTo = getRedirect(pathname, search);
    
    if (redirectTo) {
      console.log(`[SEO Redirect] ${pathname}${search} → ${redirectTo}`);
      navigate(redirectTo, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  return null;
};

export default RedirectHandler;
